export default __webpack_public_path__ + "static/cashflow_new_14-11ab52b932139907ca58fa85354ff1b1.jpg";